import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { NAV_LINKS, IMAGES } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#04100f]/85 backdrop-blur-xl border-b border-teal-500/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="#overview" onClick={(e) => { e.preventDefault(); scrollTo("#overview"); }} className="flex items-center gap-2.5 group">
          <img src={IMAGES.logo} alt="GBB LLC - Golden Bridge Business" className="h-20 w-auto object-contain" />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
              className="relative flex items-center gap-1.5 text-[15px] font-medium tracking-tight text-slate-200 hover:text-white transition-colors group"
            >
              {link.label}
              {link.badge && (
                <span className="text-[9px] font-semibold tracking-wider px-1.5 py-0.5 rounded bg-teal-500/15 text-teal-300 border border-teal-500/20">
                  {link.badge}
                </span>
              )}
              <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-teal-400 transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            onClick={() => scrollTo("#contact")}
            className="bg-gradient-to-r from-teal-400 to-emerald-500 hover:from-teal-300 hover:to-emerald-400 text-[#04100f] font-semibold rounded-lg px-6 h-11 text-[15px] shadow-lg shadow-teal-500/20 transition-all hover:shadow-teal-500/30"
          >
            Get in Touch
          </Button>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden mt-3 mx-4 rounded-2xl bg-[#071a18] border border-teal-500/10 p-5 flex flex-col gap-4 shadow-2xl">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
              className="flex items-center gap-2 text-slate-200 font-medium"
            >
              {link.label}
              {link.badge && (
                <span className="text-[9px] font-semibold tracking-wider px-1.5 py-0.5 rounded bg-teal-500/15 text-teal-300">
                  {link.badge}
                </span>
              )}
            </a>
          ))}
          <Button
            onClick={() => scrollTo("#contact")}
            className="bg-gradient-to-r from-teal-400 to-emerald-500 text-[#04100f] font-semibold rounded-lg"
          >
            Get in Touch
          </Button>
        </div>
      )}
    </header>
  );
}